import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
  options={{
    strings: ["learn...", "think...", "build...", "repeat."],
    autoStart: true,
    loop: true,
    deleteSpeed: 50,
    cursor: "|", // default is "|", you can change it
  }}
/>

  );
}

export default Type;
